import Vue from 'vue';
import Meta from 'vue-meta';
import Router from 'vue-router';
import VueAnalytics from 'vue-analytics';
import Index from '../views/Index.vue';
import store from '../store';

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Index,
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('../views/auth/Login.vue'),
        },
        {
            path: '/password/forgot',
            name: 'forgotPassword',
            component: () => import('../views/auth/ForgotPassword.vue'),
        },
        {
            path: '/password/reset/:token',
            name: 'resetPassword',
            component: () => import('../views/auth/ResetPassword.vue'),
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('../views/auth/Register.vue'),
        },
        {
            path: '/media-library',
            name: 'media_library',
            component: () => import('../views/media-library/Index.vue'),
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('../views/users/Index.vue'),
        },
        {
            path: '/users/create',
            name: 'users_create',
            component: () => import('../views/users/Create.vue'),
        },
        {
            path: '/users/:id',
            name: 'users_edit',
            component: () => import('../views/users/Edit.vue'),
        },
        {
            path: '/settings',
            name: 'settings',
            component: () => import('../views/settings/Index.vue'),
        },
        {
            path: '/pages',
            name: 'pages',
            component: () => import('../views/pages/Index.vue'),
        },
        {
            path: '/pages/create',
            name: 'pages_create',
            component: () => import('../views/pages/Create.vue'),
        },
        {
            path: '/pages/:id',
            name: 'pages_edit',
            component: () => import('../views/pages/Edit.vue'),
        },
    ],
});

const guestRotues = ['login', 'forgotPassword', 'resetPassword', 'register'];

async function checkAuth(to, from, next) {
    if (!store.getters['auth/check'] && store.getters['auth/token']) {
        try {
            await store.dispatch('auth/fetchUser');
        } catch (e) {
            store.commit('auth/LOGOUT');
            router.push({ name: 'login' });
        }
    }

    if (!guestRotues.includes(to.name) && !store.getters['auth/check']) {
        store.commit('auth/LOGOUT');
        router.push({ name: 'login' });
    } else if (guestRotues.includes(to.name) && store.getters['auth/check']) {
        router.replace({ name: 'home' });
    } else {
        next();
    }
}

router.beforeEach(checkAuth);

router.afterEach(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
});

Vue.use(VueAnalytics, {
    id: 'UA-XXX-X',
    router,
});

export default router;
